import { observable, action } from 'mobx'
import { has } from 'lodash'

import BaseListItem, {
  IBaseListItemUpdateOptions,
} from 'stores/base/BaseListItem'

export interface IEnumCreatePayload {
  id: string
  name: string
  values: string[]
}

export default class Enum extends BaseListItem {
  @observable id: string
  @observable name: string
  @observable values: string[]

  constructor(enumerable: IEnumCreatePayload) {
    super(enumerable)

    this.id = enumerable.id
    this.name = enumerable.name
    this.values = enumerable.values
  }

  @action
  update(
    enumerable: Partial<IEnumCreatePayload>,
    options: IBaseListItemUpdateOptions = {}
  ) {
    has(enumerable, 'name') && (this.name = enumerable.name!)
    has(enumerable, 'values') && (this.values = enumerable.values!)

    super.update(enumerable, options)
  }
}
